<template>
    <span class="inline-flex shrink-0" @mouseenter="open" @mouseleave="close">
        <button ref="btn" type="button" class="inline-flex cursor-help text-faint hover:text-muted focus-visible:text-muted"
            :aria-label="title" :aria-describedby="shown ? tipId : null"
            @focus="open" @blur="close" @click.stop="open" @keydown.esc="close">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                <circle cx="7" cy="7" r="5.8" stroke="currentColor" stroke-width="1.2" />
                <path d="M7 6.3v3.4M7 4.4h.01" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" />
            </svg>
        </button>
        <!-- Fixed and clamped to the viewport, so it is never cut off at the card or screen edge. -->
        <div v-if="shown" :id="tipId" ref="tip" role="tooltip" :style="pos"
            class="fixed z-[1000] w-max max-w-[280px] rounded-lg bg-inverse px-3 py-2 text-left text-[12px] leading-[1.45] text-inverse-ink shadow-[0_8px_24px_rgba(15,23,42,0.24)] pointer-events-none">
            <div class="font-semibold">{{ title }}</div>
            <div v-if="text" class="mt-0.5 text-line-strong">{{ text }}</div>
        </div>
    </span>
</template>

<script>
const GAP = 8

// Small "i" icon with a title + description tooltip. Opens on hover, keyboard
// focus or tap; closes on leave, blur, Esc, scroll or a tap elsewhere.
export default {
    name: 'InfoTip',
    props: {
        title: { type: String, default: '' },
        text: { type: String, default: '' },
    },
    data() {
        return { shown: false, pos: { top: '0px', left: '0px', visibility: 'hidden' } }
    },
    computed: {
        tipId() {
            return `info-tip-${this._uid}`
        },
    },
    methods: {
        open() {
            if (this.shown) return
            this.shown = true
            this.pos = { top: '0px', left: '0px', visibility: 'hidden' }
            window.addEventListener('scroll', this.close, true)
            window.addEventListener('resize', this.close)
            document.addEventListener('click', this.close)
            this.$nextTick(this.place)
        },
        close() {
            if (!this.shown) return
            this.shown = false
            window.removeEventListener('scroll', this.close, true)
            window.removeEventListener('resize', this.close)
            document.removeEventListener('click', this.close)
        },
        // Below the icon, or above it when there is no room; centred and kept inside the viewport.
        place() {
            const btn = this.$refs.btn
            const tip = this.$refs.tip
            if (!btn || !tip) return
            const b = btn.getBoundingClientRect()
            const t = tip.getBoundingClientRect()
            const vw = document.documentElement.clientWidth
            const vh = window.innerHeight
            const left = Math.min(Math.max(GAP, b.left + b.width / 2 - t.width / 2), Math.max(GAP, vw - t.width - GAP))
            let top = b.bottom + GAP
            if (top + t.height > vh - GAP && b.top - t.height - GAP >= GAP) top = b.top - t.height - GAP
            this.pos = { top: `${Math.round(top)}px`, left: `${Math.round(left)}px` }
        },
    },
    beforeDestroy() {
        this.close()
    },
}
</script>
